<template>
  <SidePanel
    :isVisible="true"
    @cancel="onCancel"
    :header="header"
    @save="onSave"
    :save="'Save'"
    :rightCommand="true"
    :loading="loading"
  >
    <div class="sidepanel-body">
      <div class="configure-answers" v-if="poll.choice_config">
        <p class="title-description">{{ $t('configureAnswer.description') }}</p>
        <div class="answer-options">
          <p class="font-weight-600">{{ $t('configureAnswer.mainAnswerOptions') }}</p>
          <div class="options">
            <div class="question-name text-size-12 mb-2">
              <input-text-validated
                :label="$t('configureAnswer.nameOfQuestion')"
                type="text"
                vid="cName"
                id="cName"
                v-model="poll.choice_config.nameOfQuestion"
                autocomplete="off"
              />
            </div>
            <div
              class="options-details"
              v-for="mainAnswer in getPollChoiceMainAnswerConfig"
              :key="mainAnswer.symbol_name"
            >
              <div class="options-details--icon">
                <span
                  v-if="mainAnswer.symbol_name.includes('parenthesis')"
                  data-icon="check"
                  >(</span
                >
                <font-awesome-icon
                  :icon="getIconFromName(mainAnswer.symbol_name)"
                />
                <span
                  v-if="mainAnswer.symbol_name.includes('parenthesis')"
                  data-icon="check"
                  >)</span
                >
              </div>
              <div class="options-details--textbox">
                <input-text-validated
                  rules="required"
                  type="text"
                  vid="cName"
                  id="cName"
                  v-model="mainAnswer.label"
                  autocomplete="off"
                  :readonly="true"
                />
              </div>
              <div class="options-details--usedNotUsed">
                <template v-if="mainAnswer.isCompulsory">
                  <p>{{ $t('configureAnswer.mandatory') }}</p>
                </template>
                <template v-else>
                  <select-field
                    :options="requiredInPollOptions"
                    v-model="mainAnswer.isUsedInPoll"
                    :useFullWidthClass="true"
                  />
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="addition-answer mt-2">
          <div class="header">
            <p class="font-weight-600">{{ $t('configureAnswer.additionalAnswer') }}</p>

            <span class="ml-1 beta-text"> {{ $t('configureAnswer.beta') }} </span>
            <!-- <img
              class="ml-3 flex-column border-radius premium-logo-design"
              height="50"
              srcset="/images/PremiumFavicon.png"
              alt=""
            /> -->
          </div>
          <div class="description">
            <!-- {labelValue: '', main_answer: '', who_can_answer: '', options: []} -->
            <div
              class="card mb-2 answers"
              v-for="(additionalAnswer,
              index) in getPollChoiceAdditionalAnswerConfig"
              :key="index"
            >
              <div class="answer-index">
                <p class="font-weight-500">{{ $t('configureAnswer.answer') }} {{ index + 1 }}</p>
                <font-awesome-icon
                  @click="deleteAdditionalAnswer(index)"
                  class="mb-3 mb-sm-0 pointer"
                  :icon="['fal', 'trash-alt']"
                />
              </div>
              <div class="answers--descriptive">
                <div class="answers--label mb-2">
                  <input-text-validated
                    :label="$t('configureAnswer.labelHeader')"
                    rules="required|max:24"
                    type="text"
                    vid="cName"
                    id="cName"
                    v-model="additionalAnswer.labelValue"
                    autocomplete="off"
                    ref="answers-textbox"
                  />
                </div>

                <div class="answers--options mb-3">
                  <div class="answers--onlyDisplayIf">
                    <select-field
                      :options="additionalAnswerForOnlyDisplayIf"
                      v-model="additionalAnswer.main_answer"
                      :selectHeaderLabel="$t('configureAnswer.mainAnswerIs')"
                    />
                  </div>
                  <div class="answers--whoCanAnswer">
                    <select-field
                      :options="additionalAnswerForWhoCanAnswer"
                      v-model="additionalAnswer.who_can_answer"
                      :selectHeaderLabel="$t('configureAnswer.canAnswer')"
                    />
                  </div>
                </div>
                <div>
                  <div
                    class="answers--type-option mt-2"
                    v-for="(selectionOption, index) in additionalAnswer.values"
                    :key="index"
                  >
                    <div class="type-options">
                      <p class="type-options-index">{{ index + 1 }}</p>
                      <input-text-validated
                        rules="required|max:16"
                        type="text"
                        vid="cName"
                        :id="'additionalAnswer' + index"
                        v-model="selectionOption.value"
                        autocomplete="off"
                        ref="options-textbox"
                      />
                    </div>
                    <font-awesome-icon
                      @click="deleteOption(additionalAnswer, index)"
                      class="mb-3 mb-sm-0 pointer"
                      :icon="['fal', 'trash-alt']"
                    />
                  </div>
                  <BtnLink
                    @click.native="addNewOptionForSelection(additionalAnswer)"
                    :iconLeft="['fal', 'plus-circle']"
                    :label="$t('configureAnswer.addNewOption')"
                  />
                </div>
              </div>
            </div>
          </div>
          <BtnLink
            @click.native="addNewAnswer()"
            :iconLeft="['fal', 'plus-circle']"
            :label="$t('configureAnswer.addNewAnswer')"
            v-show="hideNewAnswerLinkWhenExceedLimit"
          />
          <!-- <div class="description"> 
                    <div class="answers mt-2" v-for="(additionalAnswer, index) in getPollChoiceAdditionalAnswerConfig" :key="index"> 
                        <div class="answers--checkbox"> 
                            <input
                                type="checkbox"
                                id="days_5"
                                value="5"
                                class="mandatory-email  mr-10"
                                v-model="additionalAnswer.active"
                            />
                        </div>
                        <div class="answers--descriptive"> 
                            <div class="answers--label mb-4"> 
                                <input-text-validated
                                    :label="additionalAnswer.label"
                                    rules="required"
                                    type="text"
                                    vid="cName"
                                    id="cName"
                                    v-model="additionalAnswer.labelValue"
                                    autocomplete="off"
                                /> 
                            </div>
                            <div class="answers--type"> 
                                <select-field :options="additionalAnswerType" v-model="additionalAnswer.type" :selectHeaderLabel="additionalAnswer.type_label" />
                            </div>
                            <template v-if="additionalAnswer.type.code == 'selection'"> 
                                <div class="answers--type-option mt-2" v-for="(selectionOption, index) in additionalAnswer.options" :key="index"> 
                                    <input-text-validated
                                        rules="required"
                                        type="text"
                                        vid="cName"
                                        :id="'additionalAnswer'+index"
                                        v-model="selectionOption.value"
                                        autocomplete="off"
                                    />
                                    <font-awesome-icon
                                        @click="deleteOption(additionalAnswer, index)"
                                        class="mb-3 mb-sm-0 pointer"
                                        :icon="['fal', 'trash-alt']"
                                    />
                                </div>
                                <BtnLink @click.native="addNewOptionForSelection(additionalAnswer)" :iconLeft="['fal', 'plus-circle']" :label="'Add new option'" />
                            </template>
                        </div>
                        <div class="answers--descriptive1">
                            <div class="answers--onlyDisplayIf mb-3"> 
                                <select-field :options="additionalAnswerForOnlyDisplayIf" v-model="additionalAnswer.only_display_if" :selectHeaderLabel="additionalAnswer.only_display_if_label" />
                            </div>
                            <div class="answers--whoCanAnswer"> 
                                <select-field :options="additionalAnswerForWhoCanAnswer" v-model="additionalAnswer.who_can_answer" :selectHeaderLabel="additionalAnswer.who_can_answer_label" />
                            </div>
                        </div>
                    </div>
                </div> -->
        </div>
      </div>
    </div>
  </SidePanel>
</template>

<script>
import SidePanel from '@/components/Rendering/SidePanel.vue';
import SelectField from '@/components/UI/SelectField';
import { mapState } from 'vuex';
import { HTTP } from '@/shared/http';
import { constants } from '@/shared/constant';

export default {
  name: 'ConfigureAnswer',
  props: {
    reRenderData: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      option1: '',
      loading: false,
      additionalAnswers: [],
      wasAnswerRemoved: false,
    };
  },
  components: {
    SidePanel,
    SelectField,
  },
  computed: {
    ...mapState({
      poll: (state) => state.poll.poll,
    }),
    header() {
      return this.$t('configureAnswer.title');
    },
    getPollChoiceMainAnswerConfig() {
      return this.poll.choice_config.main_answers;
    },
    getPollChoiceAdditionalAnswerConfig() {
      return this.poll.choice_config.additional_answers;
    },
    requiredInPollOptions() {
      return [
        { code: 'use', label: 'Use' },
        { code: 'doNotUse', label: 'Do not use' },
      ];
    },
    additionalAnswerType() {
      return [
        { code: 'time', label: 'Time' },
        { code: 'text', label: 'Text' },
        { code: 'selection', label: 'Selection single' },
      ];
    },
    additionalAnswerForOnlyDisplayIf() {
      return [
        { code: 'main_answer_is_yes', icon: 'check' },
        { code: 'main_answer_is_no', icon: 'times' },
        // { code: 'always', label: 'always' },
      ];
    },
    additionalAnswerForWhoCanAnswer() {
      return [
        { code: 'admin', label: 'Admin only' },
        // { code: 'user', label: 'User only' },
        { code: 'both', label: 'Admin & User' },
      ];
    },
    hideNewAnswerLinkWhenExceedLimit() {
      return this.poll.choice_config.additional_answers.length < 3;
    },
  },
  methods: {
    getIconFromName(type) {
      let renderData = ['fas', 'check'];
      switch (type) {
        case 'checked' || 'checked with parenthesis':
          renderData = ['fas', 'check'];
          break;
        case 'crossed':
          renderData = ['fas', 'times'];
          break;
        case 'question':
          renderData = ['fas', 'question'];
          break;
      }
      return renderData;
    },
    onCancel() {
      this.$emit('cancel');
    },
    addNewOptionForSelection(additionalAnswer) {
      additionalAnswer.values.push({ value: '' });
    },
    deleteOption(additionalAnswer, index) {
      additionalAnswer.values.splice(index, 1);
    },
    async onSave() {
      let continueExecutionTillError = true;
      if(this.poll.choice_config.additional_answers.length > 0) {
        for(let i = 0; i < this.$refs['answers-textbox'].length; i++) {
          continueExecutionTillError = await this.$refs['answers-textbox'][i].validate().then((response) => response.valid);
          if(continueExecutionTillError == false) {
            return;
          }
        }
  
        for(let i = 0; i < this.$refs['options-textbox'].length; i++) {
          continueExecutionTillError = await this.$refs['options-textbox'][i].validate().then((response) => response.valid);
          if(continueExecutionTillError == false) {
            return;
          }
        }
      }
      this.loading = true;
      for(let i = 0; i < this.poll.choice_config.additional_answers.length; i++) {
        this.poll.choice_config.additional_answers[i].labelValue = this.poll.choice_config.additional_answers[i].labelValue.substring(0, 24);
      }
      if (this.wasAnswerRemoved) {
        const url = process.env.VUE_APP_API_URI_SEGMENT + '/' + this.poll.id + '/remove-choice-answers';
        HTTP.post(url, this.poll.choice_config).then((response) => {
          console.log(response);
        });
      }

      const url = process.env.VUE_APP_API_URI_SEGMENT + '/' + this.poll.id +'/choice-configure';
      HTTP.post(url, this.poll.choice_config).then((response) => {
        this.loading = false;
        console.log(response);
        this.$emit('save');
      });
    },
    addNewAnswer() {
      if (this.poll.choice_config.additional_answers.length < 3) {
        this.poll.choice_config.additional_answers.push({
          type: 'time',
          labelValue: '',
          main_answer: { code: 'main_answer_is_yes', icon: 'check' },
          who_can_answer: { code: 'both', label: 'Admin & User' },
          values: [],
        });
      }
    },
    deleteAdditionalAnswer(index) {
      this.wasAnswerRemoved = true;
      this.poll.choice_config.additional_answers.splice(index, 1);
    },
  },
  created() {
    if (this.poll.choice_config == null) {
      this.poll.choice_config = constants.defaultChoiceConfig;
    }
  },
};
</script>
<style scoped lang="scss">
@import '@/styles/style.scss';

.configure-answers {
  font-size: $small;
  padding-bottom: 50px;
  .title-description {
    font-weight: $semi-bold-weight;
  }
  .question-name {
    width: 50%;
  }
  .options-details {
    display: flex;
    justify-content: space-between;
    width: 90%;
    .options-details--usedNotUsed,
    .options-details--textbox {
      width: 33%;
      text-align: center;
    }
    .options-details--icon {
      width: 10%;
      text-align: center;
    }
  }
  .addition-answer {
    .header {
      display: flex;
    }
    .answers {
      // display: flex;
      // justify-content: space-around;
      padding: 5px 10px;
      .answer-index {
        display: flex;
        justify-content: space-between;
        svg {
          color: $primary;
        }
      }
      .answers--checkbox {
        width: 10%;
        input[type='checkbox'] {
          width: 25px;
          height: 25px;
        }
      }
      .answers--type-option {
        display: flex;
        // span {
        //     width: 75%;
        // }
        .type-options {
          display: flex;
          .type-options-index {
            margin: 0px 10px 0px 0px !important;
          }
        }
      }
      .answers--options {
        display: flex;
        justify-content: space-between;
        width: 100%;
        .answers--onlyDisplayIf {
          width: 50%;
        }
        .answers--whoCanAnswer {
          width: 50%;
        }
      }
      .answers--descriptive {
        .answers--label {
          width: 70%;
        }
      }
    }
  }
}
[data-icon='check'] {
  color: $secondary;
}
</style>
